import React from 'react'
import { Card } from 'primereact/card';
import { Col, Row, FormGroup, Input } from 'reactstrap'
import {InputMask} from 'primereact/inputmask';
import {InputTextarea} from 'primereact/inputtextarea';
import Formatacao from '@/app/util/formatacao'
import { Tooltip } from 'primereact/tooltip';


export default class Orcamento extends React.Component{

    render(){

        const { 
            id, descricao, viproc, valor, tipoObra, unidadeTrabalho ,
            engenheiroCivil, engenheiroEletricista, prazo, tabela, aprovacao,
            percentualExecucao
        } = this.props.value

        const tipo = tipoObra === 0 ? 'Construção' : 'Reforma'
        const unidadeExecutora = unidadeTrabalho && `${unidadeTrabalho.numero} -  ${unidadeTrabalho.descricao}`
        const dataAprovacao = aprovacao && Formatacao.localDate(aprovacao);

        return (
            <Card title="Dados da Obra">
                <Row>
                    <Col md={12}>
                        <FormGroup>
                            <label htmlFor="inputUnidadeExec">Unidade Executora</label>
                            <Input id="inputUnidadeExec" disabled type="text" value={unidadeExecutora} />
                        </FormGroup>
                    </Col>  
                </Row>

                <Row>
                    <Col md={3}>
                        <FormGroup>
                            <label htmlFor="inputNumero">Orçamento N°</label>
                            <Input id="inputNumero" disabled type="text" value={id} />
                        </FormGroup>
                    </Col>          

                    <Col md={3}>
                        <FormGroup>
                            <label htmlFor="inputEstimado">Valor Orçado</label>
                            <Input id="inputEstimado" disabled type="text" value={Formatacao.currency(valor)} />
                        </FormGroup>
                    </Col>   

                     <Col md={3}>
                        <FormGroup>
                            <label htmlFor="inputArrematado">Tipo de Obra</label>
                            <Input id="inputArrematado" disabled type="text" value={tipo} />
                        </FormGroup>
                    </Col>    

                    <Col md={3}>
                        <FormGroup>
                            <label htmlFor="inputAprovacao">Data Aprovação</label>
                            <Input id="inputAprovacao" disabled type="text" value={dataAprovacao} />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md={3}>
                        <FormGroup>
                            <label htmlFor="inputNumero">Processo</label>
                            <Input id="inputNumero" 
                                    className="form-control" 
                                    autoClear
                                    mask="999999?9/9999"
                                    disabled type="text" value={viproc} />
                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <label htmlFor="inputPrazo">Prazo</label>
                            <Input id="inputPrazo" disabled type="text" value={`${prazo} dias`} />
                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <label htmlFor="inputPercentualExec">Percentual de Execução (%)</label>
                            <Input id="inputPercentualExec" disabled type="text" value={percentualExecucao} 
                                   title={"Percentual de Execução se dá pela emissão dos laudos."} 
                                   tooltipOptions={{position: 'top'}}/>
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md={12}>
                        <FormGroup>
                            <label htmlFor="inputDescricao">Descrição</label>
                            <InputTextarea id="inputDescricao" disabled type="text" 
                                    value={ descricao } style={ {width: '100%'}} />
                        </FormGroup>
                    </Col>
                </Row>

                <Row>
                    <Col md={3}>
                        <FormGroup>
                            <label htmlFor="inputCivil">Engenheiro Civil</label>
                            <Input id="inputCivil" disabled type="text" value={engenheiroCivil && engenheiroCivil.nome} />
                        </FormGroup>
                    </Col>

                    <Col md={3}>
                        <FormGroup>
                            <label htmlFor="inputEletricista">Engenheiro Eletricista</label>
                            <Input id="inputEletricista" disabled type="text" value={ (engenheiroEletricista && engenheiroEletricista.nome) || ''} />
                        </FormGroup>
                    </Col>

                    <Col md={6}>
                        <FormGroup>
                            <label htmlFor="inputTabela">Tabela Seinfra</label>
                            <Input id="inputTabela" disabled type="text" value={tabela && tabela.versao} />
                        </FormGroup>
                    </Col>
                   
                </Row>

            </Card>
        )
    }
}